
import * as cloudflareRuntime$IUxLawgCI2INso8MMMDCRbq1AVklzAC9kdtyZrJmE6E from '/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/@nuxt+image@https+++pkg.pr.new+@nuxt+image@1a5786c_@netlify+blobs@8.2.0_db0@0.3.2_bette_67232f9a1a38608f472892b340607eab/node_modules/@nuxt/image/dist/runtime/providers/cloudflare'
import * as ipxRuntime$gT5svG53NpjG18XeyQ5TKZcra77iS4t8C5V1RWsiZng from '/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/@nuxt+image@https+++pkg.pr.new+@nuxt+image@1a5786c_@netlify+blobs@8.2.0_db0@0.3.2_bette_67232f9a1a38608f472892b340607eab/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import * as noneRuntime$soYPE0zBwne06HMT3Xq_45_ODKWRh0yuvri_45uAAtG0h1U from '/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/@nuxt+image@https+++pkg.pr.new+@nuxt+image@1a5786c_@netlify+blobs@8.2.0_db0@0.3.2_bette_67232f9a1a38608f472892b340607eab/node_modules/@nuxt/image/dist/runtime/providers/none'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "cloudflare",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "jpeg",
    "jpg",
    "png",
    "svg",
    "webp"
  ]
}

imageOptions.providers = {
  ['cloudflare']: { provider: cloudflareRuntime$IUxLawgCI2INso8MMMDCRbq1AVklzAC9kdtyZrJmE6E, defaults: {"baseURL":"https://nuxt.com"} },
  ['ipx']: { provider: ipxRuntime$gT5svG53NpjG18XeyQ5TKZcra77iS4t8C5V1RWsiZng, defaults: {"baseURL":"https://ipx.nuxt.com"} },
  ['none']: { provider: noneRuntime$soYPE0zBwne06HMT3Xq_45_ODKWRh0yuvri_45uAAtG0h1U, defaults: {} }
}
        